// extracted by mini-css-extract-plugin
export default {"wrapper":"Fbxi2NOebxgeAJn73dx0","table":"bhG3t_1MR8riAjLbhtnt"};